import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-176" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-177" data-mp="o3x58w0bc74w">
        <SectionHeading id="summary-title" data-id="element-178" data-mp="j883cm0tme5f">Everything <span className="text-teal-700" data-id="element-179" data-mp="j5c5sysvxrhi">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-slate-200 bg-white sm:grid-cols-2" data-id="element-180" data-mp="1gufao3oieklh">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-slate-200 p-4 sm:odd:border-r" data-id="element-181" data-mp="16wrbn1jveqxi">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-700" data-id="element-182" data-mp="12vpbmii4qauh">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-183" data-mp="3rn8k4jum20du" />
              </span>
              <b className="text-sm font-medium text-slate-900" data-id="element-184" data-mp="3nkbyek9rxo5o">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}